/** The fixed copy of the stat-block form's states (1.AC-2 deliverable 7); US English. */
export const COPY = {
  title: 'Stat block',
  newBlock: 'New stat block',
  loading: 'Loading stat block…',
  off: 'The stat-block form is turned off.',
  srd: "SRD entries can't be edited. Customize makes an editable copy.",
  noSheet: (typeName: string) => `${typeName} pages don't have stat blocks.`,
  trashed: 'This page is in the trash. Restore it to edit its stat block.',
  missing: "This page doesn't exist.",
  failed: "The stat block couldn't be loaded.",
  saved: 'Stat block saved.',
  leaveTitle: 'Leave without saving?',
  leaveBody: 'Your changes to this stat block will be lost.',
  conflict: 'This stat block was changed elsewhere.',
  lastValid: 'Showing the last valid version',
  noPreview: 'Fix the marked fields to see the preview.',
  primaryHint: 'A page keeps one primary stat block.',
  compareLoading: 'Loading the SRD entry…',
  compareMissing: 'The SRD entry this was copied from no longer exists.',
  compareFailed: "Couldn't load the SRD entry.",
  compareWithdrawn: 'The SRD entry this was copied from was withdrawn.',
  compareSame: 'No differences from the SRD entry.',
  customizeSpell: 'Homebrew spells and items come in a later release.',
  frozenWhileDirty: 'Save or discard your changes first.',
} as const;
